module.exports = __webpack_public_path__ + "media/mouth.37d2594a.mp3";